import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export default function PageHeader({ title, subtitle, backTo, right, testid = "page-header" }) {
  const navigate = useNavigate();
  return (
    <header data-testid={testid} className="px-4 md:px-8 py-4 md:py-6 bg-white border-b border-[var(--vidoc-border)]">
      <div className="flex items-start gap-3">
        {backTo && (
          <button
            data-testid="page-back-btn"
            type="button"
            onClick={() => (typeof backTo === "string" ? navigate(backTo) : navigate(-1))}
            className="p-2 -ml-2 rounded-full hover:bg-[var(--vidoc-bg-secondary)] touch-target"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
        )}
        <div className="flex-1 min-w-0">
          <h1 className="text-2xl md:text-3xl font-bold tracking-tight truncate">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-1 text-sm text-[var(--vidoc-text-secondary)]">
              {subtitle}
            </p>
          )}
        </div>
        {right}
      </div>
    </header>
  );
}
